
<template>
	<c-dialog ref="dialog" title="选择模板" width="600" height="400" enable-flex :button="false">
		<c-tips v-if="printerError"><p v-html="printerError"></p></c-tips>
		<c-tab-list v-if="tabList.length > 1" ref="tabList" :tabs="tabList" :immediate="false" type="card" @change="tabHandle"></c-tab-list>
		<c-table ref="table" height="grow" :paging="false">
		    <c-table-column label="模板类型"  name="template_type" width="80">
			    <template #default="{data}">
				    <c-state dict="templateTypeName" :value="data.template_type"></c-state>
			    </template>
		    </c-table-column>
		    <c-table-column label="模板名称"  name="template_name" width="250">
			    <template #default="{data}">
				    <span v-if="data.is_sys_template==2" style="color: #55a532">【系统】</span>{{data.template_name}}
			    </template>
		    </c-table-column>
		    <c-table-column type="button" label="操作" width="120">
				<template #default="{data}">
					<c-table-button v-if="data.template_type != 3" @click="handle(data)">打印</c-table-button>
					<c-table-button v-if="data.template_type == 2" @click="handle(data, true)">下载</c-table-button>
					<c-table-button v-if="data.template_type == 3" @click="handle(data, true)">导出</c-table-button>
				</template>
			</c-table-column>
	    </c-table>
	</c-dialog>
</template>

<script>
	import {mapState} from "vuex";
	import getLodop from '@/assets/script/lodop.js'

	export default {
	    name: 'exportTemplateSelector',

		props: {
			workType: [Number, String],
			templateType:[Number, String]   //模板类型  1=内置模板（HTML代码）  2=Excel模板  3=Excel列表模板
		},
		
		data() {
			return {
				printerError: '',
				currentTab: 1,
				templateList:[]
			}
		},

	    computed: {
		    // 获取dictName选项数据
	        ...mapState(['templateTypeName']),

		    tabList() {
			    let list = [];
			    if (this.templateType && this.templateType.toString()==3) {
				    list.push({"value":3,"name": "Excel列表模板"});
			    }else {
				    if (!['2','11','16'].includes(this.workType.toString())) {
					    list.push({"value":1, "name": "内置模板"});
				    }
				    if (!['27'].includes(this.workType.toString())) {
					    list.push({"value":2,"name": "Excel模板"});
				    }
			    }
			    return list;
		    },

		    dialogTitle() {
			    return {
				    2: '【售后工单】',
                    11: '【费用报销】',
                    16: '【报修申请单】',
				    27: '【用户】',

			    }[this.workType]
		    }
	    },

		methods: {
			open(data = {}) {
				this._excelParams = data.excelParams;
				this._htmlParams = data.htmlParams;
				if (this.tabList.length == 1){
					this.currentTab = this.tabList[0].value;
					this.loadTemplate();
				} else {
					this.$refs.tabList.changeIndex(0);
				}
				this.$refs.dialog.open({
					title: `${this.dialogTitle}${this.templateType == 3 ? '导出' : '打印'}`
				});

				// this.printerError = '';
				// if (this.tabList.find(item => item.value == 2)) {
				// 	getLodop().catch(e => {
				// 		this.printerError = e;
				// 	});
				// }
			},

			tabHandle(tab) {
				this.currentTab = tab.value;
				this.loadTemplate();
			},
			
			//加载列表
			 loadTemplate() {
				 this.$refs.table.load({
					 url: '/export/template/list',
					 data: {
						 template_type: this.currentTab,
						 work_type: this.workType
					 },
					 success: () => {
						 var list = this.$refs.table.getRow();
						 if (list && list.length > 0){
							 this.$refs.table.getRow(0).update({
								 _selected: true
							 })
						 }
					 }
				 });
			 },

			 /**
			  * 确认相应事件
			  * **/
  			 handle(data, download) {
				// if (data.template_type == 2 && !download && this.printerError) {
				// 	this.$message({
				// 		message: '请检查CLodop云打印服务是否正常启动'
				// 	})
				// 	return;
				// }
				if (data.template_type == 2 || data.template_type == 3) {
					this.request({
						url: '/export/url',
						data: Object.assign({
							export_type: data.template_type,  // 导出数据类型 1：内置模板  2：Excel打印模板  3：Excel导出模板
							template_id: data.id
						}, this._excelParams),
						loading: true,
						success: data => {
							if (download) {
								this.download({
									fileName: data.filename,
									url: data.url,
									loading: {
										message: '数据文件生成中...'
									}
								})
							} else {
								this.getApp().print(data.pdf_url);
							}
							this.$refs.dialog.close();
						}
					});
				} else {
					this.templatePrint(Object.assign({
						template_id: data.id
					}, this._htmlParams));
					this.$refs.dialog.close();
				}
			}
		}
	}
</script>